import type { Me } from "@towni/common";
import { useContext } from "react";
import { RequiredMeContext } from "./required-me.context";

function useMeFromContext(): Me;
function useMeFromContext(options: {
    disableThrowWhenMissingContext: boolean;
}): Me | undefined;
function useMeFromContext(options?: {
    disableThrowWhenMissingContext?: boolean;
}): Me | undefined {
    const me = useContext(RequiredMeContext);
    const disableThrow = !!options?.disableThrowWhenMissingContext;
    if (!me && !disableThrow) {
        throw new Error(
            "useMeFromContext must be used within a RequiredMeProvider",
        );
    }
    return me;
}

export { useMeFromContext };
